import clsx from 'clsx';

import { BubbleWrapper, BubbleItem, BubbleIcon } from './BubbleStep.style';

type BubbleStepsProps = {
  current: number;
  label: string;
  index: number;
  goToStep: (index: number) => void;
  IconName?: any;
  $lineWidth: number;
};

const BubbleSteps = ({
  current,
  label,
  index,
  goToStep,
  IconName,
  $lineWidth,
}: BubbleStepsProps) => {
  return (
    <BubbleItem
      onClick={() => goToStep(index)}
      $active={index <= current}
      className='BubbleItem'
    >
      <BubbleWrapper data-cy={label} $lineWidth={$lineWidth} className='BubbleWrapper'>
        <BubbleIcon
          active={index <= current}
          current={current === index}
          title={label}
          className={clsx('BubbleIcon', {
            wasActive: index < current,
            isCurrent: current === index,
          })}
        >
          <span>
            {(() => {
              if (IconName) return <IconName />;
              return index;
            })()}
          </span>
        </BubbleIcon>
      </BubbleWrapper>
    </BubbleItem>
  );
};

export default BubbleSteps;
